import axios from 'axios';
import { tokenStorage } from './tokenStorage';

// Create axios instance with CORS support
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
  //withCredentials: true, // Enable sending credentials with requests
});

// Request interceptor - Add Authorization header to all requests
api.interceptors.request.use(
  (config) => {
    const token = tokenStorage.getAccessToken();
    
    // Always add Authorization header for authenticated requests
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      // Remove Authorization header if no token (for public endpoints)
      delete config.headers.Authorization;
    }

    // Log requests in development
    if (process.env.NODE_ENV === 'development') {
      console.log('API Request:', {
        method: config.method?.toUpperCase(),
        url: config.url,
        hasAuthToken: !!token,
        authHeaderStatus: config.headers.Authorization ? 'Present' : 'Missing'
      });
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('API Response:', response.status, response.config.url);
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.code === 'ERR_NETWORK') {
      tokenStorage.clearTokens();
      window.location.href = '/login';
      return Promise.reject(new Error('Network error. Please check your connection.'));
    }

    if (error.response?.status === 403 && error.response?.data?.code === 'DEVICE_NOT_ALLOWED') {
      tokenStorage.clearTokens();
      window.location.href = '/login';
      return Promise.reject(new Error('Device access restricted. Please contact support.'));
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      tokenStorage.clearTokens();
      window.location.href = '/login';
      return Promise.reject(new Error('Unauthorized access. Please contact support.'));
      // originalRequest._retry = true;
      // try {
      //   const refreshToken = tokenStorage.getRefreshToken();
      //   if (refreshToken) {
      //     const response = await api.post('/auth/refresh', { refresh_token: refreshToken });
      //     tokenStorage.setTokens(response.data);
      //     originalRequest.headers.Authorization = `Bearer ${response.data.access_token}`;
      //     return api(originalRequest);
      //   }
      // } catch (refreshError) {
      //   tokenStorage.clearTokens();
      //   window.location.href = '/login';
      // }
    }

    return Promise.reject(error);
  }
);

export { api };
